import { MicrositeContent } from '@/types/microsite';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

class MicrositeService {
  async getContent(shareId: string): Promise<MicrositeContent> {
    const res = await fetch(`${API_BASE}/microsite/${shareId}`);
    if (!res.ok) {
      throw new Error(`Failed to load microsite: ${res.status}`);
    }
    return res.json();
  }

  async lookup(
    email: string,
  ): Promise<{ shareId: string; customerName: string; expiresAt: string | null }> {
    const res = await fetch(`${API_BASE}/microsite/lookup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.toLowerCase().trim() }),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(
        (data as { message?: string }).message ||
          'No active report found for this email',
      );
    }
    return res.json();
  }
}

export const micrositeService = new MicrositeService();
export { MicrositeService };
